export default {
  hero: {
    badge: "Consultoría de Negocios",
    titlePrefix: "Construye tu Negocio ",
    titleHighlight: "de la Manera Correcta",
    subtitle: "Desde la formación de LLC y licencias hasta la estructura y estrategia empresarial — guiamos a emprendedores en cada paso.",
    cta: {
      book: "Reservar una Consulta",
      explore: "Explorar Servicios"
    },
    stats: {
      llc: "Soporte de Formación",
      guidance: "Guía Personalizada",
      setup: "Configuración de Negocio"
    }
  },
  services: {
    hero: {
      badge: "Lo que Ofrecemos",
      titlePrefix: "Servicios de ",
      titleHighlight: "Consultoría Empresarial",
      subtitle: "Orientación integral para ayudarte a construir, estructurar y hacer crecer un negocio legítimo y escalable."
    },
    items: {
      llc: {
        title: "Creación de Negocio y Formación de LLC",
        desc: "Te guiamos en el proceso de establecer tu entidad comercial — desde elegir la estructura hasta formar una LLC.",
        benefits: [
          "Guía sobre LLC vs otras estructuras",
          "Guía de formación paso a paso",
          "Acuerdos operativos",
          "Guía para EIN y cuentas bancarias",
          "Conexión con red profesional",
          "Empezar de la manera correcta"
        ],
        forWho: "Emprendedores listos para formalizar."
      },
      compliance: {
        title: "Licencias y Cumplimiento",
        desc: "Navega por las licencias y permisos comerciales. Te ayudamos a entender qué necesita tu negocio para operar legalmente.",
        benefits: [
          "Identificación de licencias",
          "Resumen de cumplimiento",
          "Lista de requisitos de permisos",
          "Guía de plazos y renovaciones",
          "Referencias de expertos",
          "Evitar complicaciones legales"
        ],
        forWho: "Dueños que necesitan guía legal."
      },
      strategy: {
        title: "Estructura y Estrategia",
        desc: "Construye una base sólida con la estructura, sistemas y estrategia de crecimiento adecuados.",
        benefits: [
          "Diseño organizacional",
          "Estrategia de ingresos y precios",
          "Flujos de trabajo operativos",
          "Hoja de ruta de escalabilidad",
          "Marcos de objetivos y KPIs",
          "Posicionamiento competitivo"
        ],
        forWho: "Dueños que buscan crecimiento sostenible."
      },
      network: {
        title: "Red Profesional de Apoyo",
        desc: "Accede a nuestra red de confianza de profesionales licenciados — abogados, contadores y más.",
        benefits: [
          "Referidos a abogados",
          "Conexiones con CPAs",
          "Asesores financieros",
          "Expertos específicos por industria",
          "Presentaciones directas",
          "Coordinación continua"
        ],
        forWho: "Dueños que necesitan apoyo especializado."
      }
    },
    common: {
      forWho: "Para quién es:",
      book: "Reservar una Consulta"
    }
  },
  whoFor: {
    hero: {
      badge: "Para Quién Es",
      titlePrefix: "¿Es Esto ",
      titleHighlight: "Para Ti?",
      subtitle: "Nuestros servicios de consultoría están diseñados para personas decididas y listas para construir algo real."
    },
    items: {
      p1: { title: "Emprendedores Primerizos", desc: "Tienes una gran idea pero no sabes por dónde empezar. Te ayudamos a construir la base desde el primer día." },
      p2: { title: "Dueños de Pequeños Negocios", desc: "Ya estás operando pero necesitas formalizar, optimizar o escalar." },
      p3: { title: "Freelancers que se Formalizan", desc: "Estás listo para pasar de freelancer a dueño de negocio." },
      p4: { title: "Negocios en Crecimiento", desc: "Estás creciendo rápido y necesitas mejores sistemas y estructura." },
      p5: { title: "Dueños de Negocios en Línea", desc: "Negocios digitales que necesitan cumplimiento y estructura sólida." },
      p6: { title: "Negocios de Servicios Locales", desc: "Servicios locales que necesitan licencias y permisos para operar." }
    }
  },
  process: {
    hero: {
      badge: "El Proceso",
      titlePrefix: "Cómo ",
      titleHighlight: "Funciona",
      subtitle: "Un proceso simple diseñado para poner tu negocio en marcha — rápido."
    },
    items: {
      s1: { title: "Reservar una Consulta", desc: "Agenda una sesión estratégica gratuita para hablar sobre tus metas." },
      s2: { title: "Evaluación del Negocio", desc: "Identificamos brechas y trazamos el camino correcto a seguir." },
      s3: { title: "Plan de Acción Personalizado", desc: "Recibe una hoja de ruta personalizada con pasos claros y prioridades." },
      s4: { title: "Ejecutar y Crecer", desc: "Implementa tu plan con nuestro apoyo continuo." }
    }
  },
  cta: {
    titlePrefix: "¿Listo para Construir tu Negocio ",
    titleHighlight: "de la Manera Correcta?",
    subtitle: "Deja de adivinar y empieza a construir con confianza. Reserva una consulta gratuita hoy mismo.",
    cta: {
      book: "Reservar una Consulta Gratis",
      services: "Ver Todos los Servicios"
    }
  },
  disclaimer: {
    title: "Aviso Legal",
    text: "No ofrecemos asesoramiento legal ni financiero. Todas las decisiones deben tomarse en consulta con un profesional licenciado."
  }
};
